import script from "./ViewAllTeamsInSOP.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllTeamsInSOP.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllTeamsInSOP.vue?vue&type=style&index=0&id=8c9dd934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c9dd934"]])

export default __exports__